import { IDispute } from '../../interfaces/dispute';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { DisputeService } from '../../services/dispute.service';
import { getCombinedParameters } from '../../utils/getCombinedParameters';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  NgForm,
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { BBWTMessageService } from '../../services/message.service';
import { ConfirmationService } from 'primeng';
import { IncidentsService } from '../../services/incidents.service';
import { tryParseInt } from '../../utils/tryParseInt';

@Component({
  selector: 'dispute-details',
  templateUrl: './dispute-details.component.html',
  styles: [
    `
      .ui-grid-row:not(.no-extra-margin) {
        margin-bottom: 12px;
      }
      #add-details-form * {
        box-sizing: border-box;
      }
      #add-details-form .ui-grid-col-5 {
        margin-right: 16px;
      }
      #add-details-form textarea {
        width: 100%;
        min-height: 84px;
        resize: vertical;
      }
      #add-details-form button {
        width: 100%;
      }
      .ui-card {
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.4);
        /*border: 1px solid #bdbdbd;*/
        background-color: #f0f0f0;
        margin-bottom: 1em;
      }

      #DisputeDescription {
        word-wrap: break-word;
      }

      #TextDescription {
        word-wrap: break-word;
      }
    `,
  ],
})
export class DisputeDetailsComponent implements OnInit {
  public id: number;

  public dispute: IDispute;

  public isLoading: boolean = true;
  public notFound: boolean = false;

  public saveDisputeDetails: any = {};
  public backTo: string;
  public accessDetail: any = null;

  @ViewChild('addDisputeDetailForm')
  private form: NgForm;

  newMessageform: UntypedFormGroup;

  constructor(
    private disputeService: DisputeService,
    private incidentsService: IncidentsService,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    public messageService: BBWTMessageService,
    private router: Router,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    getCombinedParameters(this.route).subscribe((params) => {
      this.id = tryParseInt(params['id']) as number;
      this.backTo = params['backTo'];

      this.newMessageform = this.fb.group({
        newMessage: new UntypedFormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(250), NoEmptyString]),
        ),
      });

      this.route.params.subscribe((params: Params) => {
        this.id = params['id'];
      });

      this.disputeService
        .getAccessDetails(this.id)
        .then((x) => {
          this.accessDetail = x;
          if (this.accessDetail && this.accessDetail.hasAccess) {
            this.disputeService.get(this.id).then((result) => {
              this.dispute = result;
              console.log(result);
              this.saveDisputeDetails['disputeId'] = this.dispute.id;

              this.isLoading = false;

              if (!result) this.notFound = true;
              else {
                this.dispute.disputeMessages.splice(0, 1);
              }

              this.incidentsService.refreshStatistics();
            });
          } else {
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.accessDetail = { hasAccess: false };
          this.isLoading = false;
        });
    });
  }

  onSubmit() {
    this.disputeService.addDisputeDetail(this.saveDisputeDetails).then(
      (res) => {
        this.disputeService.get(this.id).then((result) => {
          this.dispute = result;
          this.dispute.disputeMessages.splice(0, 1);
        });
        this.incidentsService.refreshStatistics();
        this.saveDisputeDetails.text = '';
        this.newMessageform.reset();
      },
      (err) => {
        this.messageService.ShowError('Dispute Details', err);
      },
    );
  }

  onCloseDispute() {
    this.confirmationService.confirm({
      message: 'Mark this dispute as resolved?',
      accept: () => {
        this.disputeService.closeDispute(this.dispute.id).then(
          (res) => {
            this.disputeService.get(this.id).then((result) => {
              this.dispute = result;
              this.dispute.disputeMessages.splice(0, 1);
            });
            this.incidentsService.refreshStatistics();
          },
          (err) => {
            this.messageService.ShowError('Dispute Details', err);
          },
        );
      },
    });
  }

  back() {
    if (this.backTo) this.router.navigate([this.backTo]);
    else this.router.navigate(['/app/disputecs']);
  }
}
